import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {
  BaseApiTemplateService,
  Core2Config,
  BasicApiResponseModel,
  ApiVisa
} from '../../shared';
import {IntercompanyContainerModel} from '../../../../../../models/aggregates/intercompany';
import { Observable } from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class IntercompanyBranchService extends BaseApiTemplateService<IntercompanyContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +  'entity-branch-hdrs/backoffice-ep';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-branch-hdrs/backoffice-ep';
    this.httpClient = http;
  }

  createIntercompanyBranch(payload: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    return this.httpClient.post<BasicApiResponseModel<any>>(
      this.apiUrl,
      payload,
      this.getHttpHeader(visa)
    );
  }

  getByEntity(payload: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/query/snapshot?entity_hdr_guids=' + payload.guid
    }

    return this.httpClient.get<BasicApiResponseModel<any>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }

  getByBranch(payload: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/query/snapshot?branch_hdr_guids=' + payload.guid
    }

    return this.httpClient.get<BasicApiResponseModel<any>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }
}
